import url from "../components/config/Config";

export const getImage = (urlImage) => {
    if (!urlImage || urlImage === "") {
        return "http://dev.jucumari.mifacodi.com/empresas/react/sucursal1/image/categoria/noimagen.jpg";
    }
    let ar = "" + urlImage;
    ar = ar.replace("/var/www/html", url.serviceImg);
    return ar;
};
